'use es6';

import { connect } from 'react-redux';
import PagesSidePanel from './PagesSidePanel';
import * as formsSelectors from 'ContentData/selectors/forms';
const mapStateToProps = (state, props) => ({
  pages: formsSelectors.getParentPages(state, props.formGuid)
});
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(PagesSidePanel);